<!-- BR - 数据Diagnosis Chart组件 -->
<template>
  <div>
    <div v-if="tagData[chartkey]" class="chart-mode-choose">
      <div
        v-for="(item, index) in tagData[chartkey]"
        :key="index"
        :class="{ 'mode-tag': true, 'mode-selected': index === currentMode }"
        @click="chooseMode(index)"
      >
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div class="chart-canvas-container">
      <div
        ref="wrap"
        :class="{ 'chart-canvas': true, 'chart-canvas-hor': direction === 'horizontal' }"
        :style="{ height: height + 'px' }"
      ></div>
      <div
        v-if="direction === 'vertical'"
        class="chart-canvas-btn"
        :style="
          chartOptions.grid
            ? { bottom: chartOptions.grid.bottom + 'px', right: chartOptions.grid.right + 'px' }
            : {}
        "
        @click="showHor"
        @click.stop="showHor(chartkey)"
      >
        <i class="crm-quanping"></i>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import EventBus from './../../../utils/eventBus'

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 0,
    },
    chartkey: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'vertical',
    },
  },
  data() {
    return {
      currentMode: 0,
      tagData: {
        // 投资&营销 -- Tag 在外层展示，此处隐藏：
        // promotion: [
        //   {
        //     name: this.$t('FoodB_APP_WsXR_yQpy' /** 投资 */),
        //   },
        //   {
        //     name: this.$t('FoodB_APP_eiHc_XFQQ' /** 营销占比 */),
        //   },
        // ],
        // 用户
        users: [
          {
            name: this.$t('FoodB_20250414_QcoH_HIDg' /** 全部用户 */),
          },
          {
            name: this.$t('FoodB_20250414_faVK_FFkd' /** 比例 */),
          },
        ],
      },
    }
  },
  computed: {
    chartOptions() {
      console.log('[ModesChart] log', this.chartkey, this.options[this.currentMode])
      return this.options[this.currentMode] || {}
    },
  },
  watch: {
    options(nVal, oVal) {
      if (nVal !== oVal) {
        this.currentMode = 0
        if (this.direction === 'vertical') {
          this.init()
        } else {
          this.Horinit()
        }
      }
    },
    currentMode(nVal, oVal) {
      if (nVal !== oVal) {
        this.$emit('changeChartMode', nVal)
      }
    },
  },
  mounted() {
    this.currentMode = 0
    if (this.direction === 'vertical') {
      this.init()
    } else {
      this.Horinit()
    }
    // 接受到点击了其他区域的消息，隐藏图表的tooltip
    EventBus.$on('handleToolTipClose', () => {
      this.charts.dispatchAction({
        type: 'hideTip',
      })
    })
  },
  methods: {
    showHor(chartKey) {
      this.$emit('showHorCharts', chartKey)
    },
    chooseMode(index) {
      if (this.currentMode !== index) {
        this.currentMode = index
        this.init()
      }
    },
    Horinit() {
      setTimeout(() => {
        if (!this.charts) {
          this.charts = echarts.init(this.$refs.wrap)
        }
        if (this.chartOptions) {
          // 必须clear, 否则图表切换tooltip展示有问题
          this.charts.clear()
          this.charts.setOption(this.chartOptions)
          this.charts.resize()
        }
      }, 0)
    },
    setCurrentMode(mode) {
      this.currentMode = mode
      this.init()
    },
    init() {
      if (!this.charts) {
        this.charts = echarts.init(this.$refs.wrap)
      }
      if (this.chartOptions) {
        this.charts.setOption(this.chartOptions, { notMerge: true }) // 强制重新加载
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-canvas {
  position: relative;
  margin-top: 32px;
  margin-bottom: 12px;
}
.chart-canvas-hor {
  margin-top: 8px;
}
.chart-canvas-container {
  position: relative;
  .crm-quanping {
    width: 18px;
    height: 18px;
    font-size: 18px;
    color: #ffffff;
  }
  .chart-canvas-btn {
    position: absolute;
    width: 40px;
    height: 40px;
    opacity: 0.6;
    background: #000000;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.chart-mode-choose {
  display: flex;
  margin-top: 40px;
  .mode-tag {
    height: 32px;
    background: #f0f1f5;
    border-radius: 12px;
    padding: 8px 16px;
    margin-right: 24px;
    font-size: 24px;
    p {
      line-height: 32px;
      color: #595c66;
    }
  }
  .mode-selected {
    background: #ffefe7;
    p {
      color: #f76a31;
    }
  }
}
</style>
